import React from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { HomeIcon, BrainIcon, HeartIcon, TrendingUpIcon, CheckCircleIcon, ActivityIcon, BookOpenIcon, SmileIcon, ZapIcon } from 'lucide-react';
export function KidsPerformance() {
  const {
    childId
  } = useParams<{
    childId: string;
  }>();
  const navigate = useNavigate();
  // Mock data for both kids
  const kidsData = {
    'kid-1': {
      name: '佳宝',
      age: '1岁2个月',
      avatar: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
      mentalDevelopment: {
        overall: 85,
        categories: [{
          name: 'Language Skills',
          score: 90,
          color: 'bg-blue-500'
        }, {
          name: 'Problem Solving',
          score: 85,
          color: 'bg-purple-500'
        }, {
          name: 'Memory',
          score: 80,
          color: 'bg-indigo-500'
        }, {
          name: 'Creativity',
          score: 88,
          color: 'bg-pink-500'
        }],
        milestones: [{
          title: 'Speaks in complete sentences',
          achieved: true
        }, {
          title: 'Counts to 20',
          achieved: true
        }, {
          title: 'Recognizes letters',
          achieved: true
        }, {
          title: 'Basic reading skills',
          achieved: false
        }]
      },
      physicalDevelopment: {
        overall: 82,
        categories: [{
          name: 'Gross Motor Skills',
          score: 85,
          color: 'bg-green-500'
        }, {
          name: 'Fine Motor Skills',
          score: 78,
          color: 'bg-teal-500'
        }, {
          name: 'Coordination',
          score: 82,
          color: 'bg-emerald-500'
        }, {
          name: 'Balance',
          score: 84,
          color: 'bg-lime-500'
        }],
        milestones: [{
          title: 'Hops on one foot',
          achieved: true
        }, {
          title: 'Catches a ball',
          achieved: true
        }, {
          title: 'Uses scissors',
          achieved: true
        }, {
          title: 'Rides a bicycle',
          achieved: false
        }]
      },
      recentActivities: [{
        title: 'Completed "ABC Learning" lesson',
        time: '2 hours ago',
        points: 15,
        color: 'blue'
      }, {
        title: 'Practiced catching ball for 20 minutes',
        time: 'Yesterday',
        points: 10,
        color: 'green'
      }, {
        title: 'Read 3 new books',
        time: '2 days ago',
        points: 20,
        color: 'purple'
      }]
    },
    'kid-2': {
      name: '诚宝',
      age: '2岁6个月',
      avatar: 'https://images.unsplash.com/photo-1519340241574-2cec6aef0c01?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
      mentalDevelopment: {
        overall: 88,
        categories: [{
          name: 'Language Skills',
          score: 92,
          color: 'bg-blue-500'
        }, {
          name: 'Problem Solving',
          score: 90,
          color: 'bg-purple-500'
        }, {
          name: 'Memory',
          score: 85,
          color: 'bg-indigo-500'
        }, {
          name: 'Creativity',
          score: 86,
          color: 'bg-pink-500'
        }],
        milestones: [{
          title: 'Reads chapter books independently',
          achieved: true
        }, {
          title: 'Solves basic math problems',
          achieved: true
        }, {
          title: 'Writes short stories',
          achieved: true
        }, {
          title: 'Understands fractions',
          achieved: false
        }]
      },
      physicalDevelopment: {
        overall: 90,
        categories: [{
          name: 'Gross Motor Skills',
          score: 92,
          color: 'bg-green-500'
        }, {
          name: 'Fine Motor Skills',
          score: 88,
          color: 'bg-teal-500'
        }, {
          name: 'Coordination',
          score: 90,
          color: 'bg-emerald-500'
        }, {
          name: 'Balance',
          score: 90,
          color: 'bg-lime-500'
        }],
        milestones: [{
          title: 'Rides bike without training wheels',
          achieved: true
        }, {
          title: 'Swims independently',
          achieved: true
        }, {
          title: 'Plays team sports',
          achieved: true
        }, {
          title: 'Does skateboard tricks',
          achieved: false
        }]
      },
      recentActivities: [{
        title: 'Completed advanced math quiz',
        time: '1 hour ago',
        points: 25,
        color: 'blue'
      }, {
        title: 'Soccer practice - scored 2 goals',
        time: 'Today',
        points: 20,
        color: 'green'
      }, {
        title: 'Finished science project',
        time: 'Yesterday',
        points: 30,
        color: 'purple'
      }]
    }
  };
  const childData = kidsData[childId as keyof typeof kidsData] || kidsData['kid-1'];
  const getActivityColorClasses = (color: string) => {
    const colorMap: Record<string, {
      bg: string;
      text: string;
    }> = {
      blue: {
        bg: 'bg-blue-50',
        text: 'text-blue-600'
      },
      green: {
        bg: 'bg-green-50',
        text: 'text-green-600'
      },
      purple: {
        bg: 'bg-purple-50',
        text: 'text-purple-600'
      }
    };
    return colorMap[color] || colorMap.blue;
  };
  return <div className="min-h-screen bg-gradient-to-b from-purple-50 to-blue-50" data-id="element-235">
      <div className="bg-white shadow-sm sticky top-0 z-10" data-id="element-236">
        <div className="container mx-auto px-4 py-4 max-w-6xl" data-id="element-237">
          <Link to="/" className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium active:scale-95 transition-transform" data-id="element-238">
            <HomeIcon size={20} className="mr-2" data-id="element-239" />
            Back to Dashboard
          </Link>
        </div>
      </div>
      <main className="container mx-auto px-4 py-8 max-w-6xl" data-id="element-240">
        <div className="bg-white rounded-xl shadow-md p-6 mb-6" data-id="element-241">
          <div className="flex items-center" data-id="element-242">
            <img src={childData.avatar} alt={childData.name} className="w-20 h-20 rounded-full object-cover border-4 border-indigo-100" data-id="element-243" />
            <div className="ml-4" data-id="element-244">
              <h1 className="text-2xl font-bold text-gray-800" data-id="element-245">
                {childData.name}
              </h1>
              <p className="text-gray-600" data-id="element-246">{childData.age}</p>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-247">
          <div className="bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl shadow-md p-6 text-white" data-id="element-248">
            <div className="flex items-center justify-between mb-4" data-id="element-249">
              <div className="flex items-center" data-id="element-250">
                <BrainIcon size={32} className="mr-3" data-id="element-251" />
                <h2 className="text-2xl font-bold" data-id="element-252">Mental Development</h2>
              </div>
              <div className="text-right" data-id="element-253">
                <div className="text-3xl font-bold" data-id="element-254">
                  {childData.mentalDevelopment.overall}%
                </div>
                <div className="text-sm opacity-90" data-id="element-255">Overall Score</div>
              </div>
            </div>
            <div className="space-y-3" data-id="element-256">
              {childData.mentalDevelopment.categories.map(category => <div key={category.name} data-id="element-257">
                  <div className="flex justify-between text-sm mb-1" data-id="element-258">
                    <span data-id="element-259">{category.name}</span>
                    <span className="font-semibold" data-id="element-260">{category.score}%</span>
                  </div>
                  <div className="w-full bg-white bg-opacity-20 rounded-full h-2" data-id="element-261">
                    <div className="bg-white h-2 rounded-full transition-all" style={{
                  width: `${category.score}%`
                }} data-id="element-262"></div>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="bg-gradient-to-br from-green-500 to-teal-600 rounded-xl shadow-md p-6 text-white" data-id="element-263">
            <div className="flex items-center justify-between mb-4" data-id="element-264">
              <div className="flex items-center" data-id="element-265">
                <HeartIcon size={32} className="mr-3" data-id="element-266" />
                <h2 className="text-2xl font-bold" data-id="element-267">Physical Development</h2>
              </div>
              <div className="text-right" data-id="element-268">
                <div className="text-3xl font-bold" data-id="element-269">
                  {childData.physicalDevelopment.overall}%
                </div>
                <div className="text-sm opacity-90" data-id="element-270">Overall Score</div>
              </div>
            </div>
            <div className="space-y-3" data-id="element-271">
              {childData.physicalDevelopment.categories.map(category => <div key={category.name} data-id="element-272">
                  <div className="flex justify-between text-sm mb-1" data-id="element-273">
                    <span data-id="element-274">{category.name}</span>
                    <span className="font-semibold" data-id="element-275">{category.score}%</span>
                  </div>
                  <div className="w-full bg-white bg-opacity-20 rounded-full h-2" data-id="element-276">
                    <div className="bg-white h-2 rounded-full transition-all" style={{
                  width: `${category.score}%`
                }} data-id="element-277"></div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-278">
          <div className="bg-white rounded-xl shadow-md p-6" data-id="element-279">
            <div className="flex items-center mb-4" data-id="element-280">
              <BookOpenIcon size={24} className="text-indigo-600 mr-2" data-id="element-281" />
              <h3 className="text-xl font-bold text-gray-800" data-id="element-282">
                Mental Milestones
              </h3>
            </div>
            <div className="space-y-3" data-id="element-283">
              {childData.mentalDevelopment.milestones.map((milestone, index) => <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg" data-id="element-284">
                    {milestone.achieved ? <CheckCircleIcon size={20} className="text-green-500 mr-3 flex-shrink-0" data-id="element-285" /> : <div className="w-5 h-5 border-2 border-gray-300 rounded-full mr-3 flex-shrink-0" data-id="element-286"></div>}
                    <span className={`text-sm ${milestone.achieved ? 'text-gray-700' : 'text-gray-500'}`} data-id="element-287">
                      {milestone.title}
                    </span>
                  </div>)}
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-md p-6" data-id="element-288">
            <div className="flex items-center mb-4" data-id="element-289">
              <ActivityIcon size={24} className="text-green-600 mr-2" data-id="element-290" />
              <h3 className="text-xl font-bold text-gray-800" data-id="element-291">
                Physical Milestones
              </h3>
            </div>
            <div className="space-y-3" data-id="element-292">
              {childData.physicalDevelopment.milestones.map((milestone, index) => <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg" data-id="element-293">
                    {milestone.achieved ? <CheckCircleIcon size={20} className="text-green-500 mr-3 flex-shrink-0" data-id="element-294" /> : <div className="w-5 h-5 border-2 border-gray-300 rounded-full mr-3 flex-shrink-0" data-id="element-295"></div>}
                    <span className={`text-sm ${milestone.achieved ? 'text-gray-700' : 'text-gray-500'}`} data-id="element-296">
                      {milestone.title}
                    </span>
                  </div>)}
            </div>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-md p-6 mt-6" data-id="element-297">
          <div className="flex items-center mb-4" data-id="element-298">
            <TrendingUpIcon size={24} className="text-indigo-600 mr-2" data-id="element-299" />
            <h3 className="text-xl font-bold text-gray-800" data-id="element-300">
              Recent Activities
            </h3>
          </div>
          <div className="space-y-3" data-id="element-301">
            {childData.recentActivities.map((activity, index) => {
            const colors = getActivityColorClasses(activity.color);
            return <div key={index} className={`flex items-center p-4 ${colors.bg} rounded-lg`} data-id="element-302">
                  {activity.color === 'blue' && <SmileIcon size={20} className={colors.text + ' mr-3'} data-id="element-303" />}
                  {activity.color === 'green' && <ZapIcon size={20} className={colors.text + ' mr-3'} data-id="element-304" />}
                  {activity.color === 'purple' && <BookOpenIcon size={20} className={colors.text + ' mr-3'} data-id="element-305" />}
                  <div className="flex-1" data-id="element-306">
                    <p className="text-sm font-medium text-gray-800" data-id="element-307">
                      {activity.title}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-308">{activity.time}</p>
                  </div>
                  <span className={`text-sm font-semibold ${colors.text}`} data-id="element-309">
                    +{activity.points} pts
                  </span>
                </div>;
          })}
          </div>
        </div>
      </main>
    </div>;
}